// Single source of truth for the Cognito user pool / app client.
// Login (AuthProvider in index.tsx) and logout (useLogout) must point at the
// same pool, client and hosted-UI domain — otherwise logout hits a different
// pool, the real SSO session cookie survives, and the user is signed straight
// back in on the next redirect.

const isLocalhost =
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1';

const APP_ORIGIN = isLocalhost ? 'http://localhost:3000' : 'https://app.soc-mate.com';

export const COGNITO_AUTHORITY = 'https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_n6Tv5QX7c';
export const COGNITO_CLIENT_ID = '33s1c8k8vgkrghuek14ute0f7a';
// Hosted UI domain for the pool above (see end_session_endpoint in
// ${COGNITO_AUTHORITY}/.well-known/openid-configuration).
export const COGNITO_DOMAIN = 'https://socmate-dev.auth.eu-west-1.amazoncognito.com';

export const REDIRECT_URI = APP_ORIGIN;
// Must exactly match an entry under "Allowed sign-out URLs" on the app client —
// currently only the bare origins (no path, no trailing slash) are registered.
// Anything else makes Cognito bounce to its /login error page instead of
// logging out. The justLoggedOut sessionStorage flag set in useLogout keeps
// LoginPage from auto-redirecting back into Cognito once we land here.
export const LOGOUT_REDIRECT_URI = APP_ORIGIN;

export const buildCognitoLogoutUrl = () =>
    `${COGNITO_DOMAIN}/logout?client_id=${COGNITO_CLIENT_ID}&logout_uri=${encodeURIComponent(LOGOUT_REDIRECT_URI)}`;
